import React, { Component } from 'react'
import { withRouter } from 'react-router'
import { Link } from 'react-router-dom'
import { IMAGE_DOMAIN } from 'config' 
import ScrollReveal from 'scrollreveal'
import TileList from 'components/TileList'
import BrandNav from 'components/BrandNav'
import './styles.css'

// const morphyrichardsProducts = [
//   {
// 		id: 1,
//     imageSrc: `${IMAGE_DOMAIN}morphyrichards/1/00_800x693.jpg`,
//     category: '電水壺',
//     productName: '湛藍電水壺',
//     price: 'NT. 3800',
//     // discountPrice: 'NT. 3800',
//     link: '/morphyrichards/products/1'
//   },
//   {
// 		id: 2,
//     imageSrc: `${IMAGE_DOMAIN}morphyrichards/2/00_800x693.jpg`,
//     category: '快煮壺',
//     productName: '快煮笛音壺(鉻黃)',
//     price: 'NT. 2950',
//     // discountPrice: 'NT. 2950',
//     link: '/morphyrichards/products/2'
//   },
//   {
// 		id: 3,
//     imageSrc: `${IMAGE_DOMAIN}morphyrichards/3/00_800x693.jpg`,
//     category: '快煮壺',
//     productName: '快煮笛音壺(紫)',
//     price: 'NT. 2950',
//     // discountPrice: 'NT. 2950',
//     link: '/morphyrichards/products/3'
//   },
//   {
// 		id: 4,
//     imageSrc: `${IMAGE_DOMAIN}morphyrichards/4/00_800x693.jpg`,
//     category: '快煮壺',
//     productName: '快煮笛音壺(藍)',
//     price: 'NT. 2950',
//     // discountPrice: 'NT. 2950',
//     link: '/morphyrichards/products/4'
//   },
//   {
// 		id: 5,
//     imageSrc: `${IMAGE_DOMAIN}morphyrichards/5/00_800x693.jpg`,
//     category: '快煮壺',
//     productName: '快煮笛音壺(紅)',
//     price: 'NT. 2950',
//     // discountPrice: 'NT. 2950',
//     link: '/morphyrichards/products/5'
//   },
//   {
// 		id: 6,
//     imageSrc: `${IMAGE_DOMAIN}morphyrichards/6/00_800x693.jpg`,
//     category: '電水壺',
//     productName: '即熱電水壺',
//     price: 'NT. 4500',
//     // discountPrice: 'NT. 4500',
//     link: '/morphyrichards/products/6'
//   },
//   {
// 		id: 7,
//     imageSrc: `${IMAGE_DOMAIN}morphyrichards/7/00_800x693.jpg`,
//     category: '快煮濾水壺',
//     productName: 'BRITA快煮濾水壺(珍珠白)',
//     price: 'NT. 2800',
//     // discountPrice: 'NT. 2800',
//     link: '/morphyrichards/products/7'
//   },
//   {
// 		id: 8,
//     imageSrc: `${IMAGE_DOMAIN}morphyrichards/8/00_800x693.jpg`,
//     category: '沏茶壺',
//     productName: '沏茶壺',
//     price: 'NT. 4500',
//     // discountPrice: 'NT. 4500',
//     link: '/morphyrichards/products/8'
//   },
//   {
// 		id: 9,
//     imageSrc: `${IMAGE_DOMAIN}morphyrichards/9/00_800x693.jpg`,
//     category: '烤麵包機',
//     productName: '九段溫控不鏽鋼烤麵包機',
//     price: 'NT. 2800',
//     // discountPrice: 'NT. 2800',
//     link: '/morphyrichards/products/9'
//   },
//   {
// 		id: 10,
//     imageSrc: `${IMAGE_DOMAIN}morphyrichards/10/00_800x693.jpg`,
//     category: '咖啡機',
//     productName: '滴漏咖啡機',
//     price: 'NT. 4200',
//     // discountPrice: 'NT. 4200',
//     link: '/morphyrichards/products/10'
//   },
//   {
// 		id: 11,
//     imageSrc: `${IMAGE_DOMAIN}morphyrichards/11/00_800x693.jpg`,
//     category: '製麵包機',
//     productName: '全自動智慧型製麵包機',
//     price: 'NT. 7600',
//     // discountPrice: 'NT. 7600',
//     link: '/morphyrichards/products/11'
//   },
//   {
// 		id: 12,
//     imageSrc: `${IMAGE_DOMAIN}morphyrichards/12/00_800x693.jpg`,
//     category: '蒸氣拖把',
//     productName: '9合1複合式蒸氣拖把',
//     price: 'NT. 6500',
//     // discountPrice: 'NT. 6500',
//     link: '/morphyrichards/products/kettle'
//   },
//   {
// 		id: 13,
//     imageSrc: `${IMAGE_DOMAIN}morphyrichards/13/00_800x693.jpg`,
//     category: '蒸氣拖把',
//     productName: '12合1複合式蒸氣拖把',
//     price: 'NT. 6800',
//     // discountPrice: 'NT. 6800',
//     link: '/morphyrichards/products/13'
//   }
// ]

// const microdryProducts = [
//   {
// 		id: 1,
//     imageSrc: `${IMAGE_DOMAIN}microdry/1/00.jpg`,
//     category: '浴墊',
//     productName: '快乾記憶綿浴墊【時尚黑/ S】',
//     price: 'NT. 780',
//     discountPrice: 'NT. 399',
//     link: '/microdry/products/1'
//   },
//   {
// 		id: 2,
//     imageSrc: `${IMAGE_DOMAIN}microdry/2/00.jpg`,
//     category: '浴墊',
//     productName: '快乾記憶綿浴墊【沉穗褐/ S】',
//     price: 'NT. 780',
//     discountPrice: 'NT. 399',
//     link: '/microdry/products/2'
//   },
//   {
// 		id: 3,
//     imageSrc: `${IMAGE_DOMAIN}microdry/3/00.jpg`,
//     category: '浴墊',
//     productName: '快乾記憶綿浴墊【銀宇灰/ S】',
//     price: 'NT. 780',
//     discountPrice: 'NT. 399',
//     link: '/microdry/products/3'
//   },
//   {
// 		id: 4,
//     imageSrc: `${IMAGE_DOMAIN}microdry/4/00.jpg`,
//     category: '浴墊',
//     productName: '快乾記憶綿浴墊【復刻藍/ S】',
//     price: 'NT. 780',
//     discountPrice: 'NT. 399',
//     link: '/microdry/products/4'
//   },
//   {
// 		id: 5,
//     imageSrc: `${IMAGE_DOMAIN}microdry/5/00.jpg`,
//     category: '浴墊',
//     productName: '快乾記憶綿浴墊【時尚黑/ L】',
//     price: 'NT. 780',
//     discountPrice: 'NT. 399',
//     link: '/microdry/products/5'
//   },
//   {
// 		id: 6,
//     imageSrc: `${IMAGE_DOMAIN}microdry/6/00.jpg`,
//     category: '浴墊',
//     productName: '快乾記憶綿浴墊【沉穗褐/ L】',
//     price: 'NT. 780',
//     discountPrice: 'NT. 399',
//     link: '/microdry/products/6'
//   },
//   {
// 		id: 7,
//     imageSrc: `${IMAGE_DOMAIN}microdry/7/00.jpg`,
//     category: '浴墊',
//     productName: '快乾記憶綿浴墊【銀宇灰/ L】',
//     price: 'NT. 780',
//     discountPrice: 'NT. 399',
//     link: '/microdry/products/7'
//   },
//   {
// 		id: 8,
//     imageSrc: `${IMAGE_DOMAIN}microdry/8/00.jpg`,
//     category: '浴墊',
//     productName: '快乾記憶綿浴墊【復刻藍/ L】',
//     price: 'NT. 780',
//     discountPrice: 'NT. 399',
//     link: '/microdry/products/8'
//   }
// ]  

const askoProducts = [
  {
		id: 1,
    imageSrc: `${IMAGE_DOMAIN}asko/1/00.png`,
    category: '冰箱',
    productName: 'RFN2386SR / L',
    price: 'NT. 88,000',
    link: '/asko/products/1'
  },
  {
		id: 2,
    imageSrc: `${IMAGE_DOMAIN}asko/2/00.png`,
    category: '洗碗機',
    productName: 'DBI133I.W / S',
    price: 'NT. 69,000 / 74,000',
    link: '/asko/products/2'
  },
  {
		id: 3,
    imageSrc: `${IMAGE_DOMAIN}asko/3/00.png`,
    category: '洗碗機',
    productName: 'DBI654IB.W / S',
    price: 'NT. 88,000 / 93,000',
    link: '/asko/products/3'
  },
  {
		id: 4,
    imageSrc: `${IMAGE_DOMAIN}asko/4/00.png`,
    category: '洗碗機',
    productName: 'DFI633',
    price: 'NT. 76,000',
    link: '/asko/products/4'
  },
  {
		id: 5,
    imageSrc: `${IMAGE_DOMAIN}asko/5/00.png`,
    category: '洗碗機',
    productName: 'DFI654B',
    price: 'NT. 92,000',
    link: '/asko/products/5'
  },
  {
		id: 6,
    imageSrc: `${IMAGE_DOMAIN}asko/6/00.png`,
    category: '洗碗機',
    productName: 'DFS133I.W',
    price: 'NT. 72,000',
    link: '/asko/products/6'
  },
  {
		id: 7,
    imageSrc: `${IMAGE_DOMAIN}asko/7/00.png`,
    category: '洗碗機',
    productName: 'DFS143I.S',
    price: 'NT. 84,000',
    link: '/asko/products/7'
  },
  {
		id: 8,
    imageSrc: `${IMAGE_DOMAIN}asko/8/00.png`,
    category: '洗衣機',
    productName: 'W2084C.W.TW',
    price: 'NT. 66,000',
    link: '/asko/products/8'
  },
  {
		id: 9,
    imageSrc: `${IMAGE_DOMAIN}asko/9/00.png`,
    category: '洗衣機',
    productName: 'W4086C.W.TW',
    price: 'NT. 88,000',
    link: '/asko/products/9'
  },
  {
		id: 10,
    imageSrc: `${IMAGE_DOMAIN}asko/10/00.png`,
    category: '洗衣機',
    productName: 'W4114C.W.TW',
    price: 'NT. 99,800',
    link: '/asko/products/10'
  },
  {
		id: 11,
    imageSrc: `${IMAGE_DOMAIN}asko/11/00.png`,
    category: '烘衣機',
    productName: 'T208C.W',
    price: 'NT. 72,000',
    link: '/asko/products/11'
  },
  {
		id: 12,
    imageSrc: `${IMAGE_DOMAIN}asko/12/00.png`,
    category: '烘衣機',
    productName: 'T411HD',
    price: 'NT. 99,800',
    link: '/asko/products/12'
  },
  {
		id: 13,
    imageSrc: `${IMAGE_DOMAIN}asko/13/00.png`,
    category: '蒸烤爐',
    productName: 'OCS8456S / OCS8476S',
    price: 'NT. 95,000 / 115,000',
    link: '/asko/products/13'
  },
  {
		id: 14,
    imageSrc: `${IMAGE_DOMAIN}asko/14/00.png`,
    category: '蒸烤爐',
    productName: 'OCS8656S / OCS8676S',
    price: 'NT. 115,000 / 145,000',
    link: '/asko/products/14'
  },
]

class Product extends Component {
  // static propTypes = {
  //   position: PropTypes.oneOf(['fixed', 'absolue', 'sticky'])
  // }

  componentDidMount() {
    document.title = 'Product'
    window.scrollTo(0, 0)

    const scrollReveal = ScrollReveal()

    scrollReveal.reveal('.masonry__item', {
      origin: 'bottom',
      mobile: false,
      duration: 800,
      distance: '10%',
      scale: 1,
      easing: 'ease'
    })
  }

  render = () => {
    const brandId = this.props.match.params.brand
    let products
    switch (brandId) {
      // case 'microdry':
      //   products = microdryProducts
      //   break
      case 'asko':
        products = askoProducts
        break
      default:
        // products = morphyrichardsProducts
    }

    return (
      <div style={{ marginTop: '65px' }}>
        <BrandNav brand={brandId}/>
        <section className="masonry-contained" style={{ marginTop: '30px' }}>
          <div className="container">
            <div className="row">
              <TileList items={products.map(product => this.renderProduct(product))} />
            </div>
          </div>
        </section>
      </div>
    )
  }

  renderProduct = (product) => (
    <Link to={product.link}>
      <div className="card card-7">
        <div className="card__image">
          <img alt="Pic" src={product.imageSrc} />
        </div>
        <div className="card__body boxed" style={{background: "#EEEEEE"}}>
          <div className="card__title">
            <h6>{product.category}</h6>
            <h5>{product.productName}</h5>
          </div>
          <div className="card__price">
            <span className={product.discountPrice ? 'type--strikethrough' : ''}>{product.price}</span>
            <span>{product.discountPrice}</span>
          </div>
        </div>
      </div>
    </Link>
  )
}

export default withRouter(Product)



// WEBPACK FOOTER //
// ./src/containers/Product/index.js